import { render } from "./TableButtonEdit.vue?vue&type=template&id=554618ec"
import script from "./TableButtonEdit.vue?vue&type=script&lang=js"
export * from "./TableButtonEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__